"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVaultState = exports.ProposalState = exports.BanxTokenStakeState = exports.BanxStakingSettingsState = exports.BanxAdventureState = exports.BanxAdventureSubscriptionState = exports.AdventureState = exports.BanxStakeState = exports.BondEventType = exports.AutocompoundType = exports.BondTradeTransactionV2Type = exports.AutocompoundDepositState = exports.NftBoxState = exports.NftBoxType = exports.NftValidationDurationType = exports.ScopeType = exports.AuthorityState = exports.AuthorityType = exports.PairAuthorityType = exports.PairState = exports.RedeemResult = exports.LendingTokenType = exports.RepayDestination = exports.WhitelistType = exports.PairTokenType = exports.PairValidationType = exports.MarketTrustType = exports.MarketState = exports.OraclePriceFeedType = exports.OrderType = exports.NftValidationWhitelistType = exports.PairType = exports.BondingCurveType = exports.BondFeatures = exports.CollateralBoxType = exports.BondTradeTransactionV2State = exports.FraktBondState = void 0;
var FraktBondState;
(function (FraktBondState) {
    FraktBondState["Initialized"] = "initialized";
    FraktBondState["Active"] = "active";
    FraktBondState["Repaid"] = "repaid";
    FraktBondState["Liquidating"] = "liquidating";
    FraktBondState["Liquidated"] = "liquidated";
    FraktBondState["PerpetualActive"] = "perpetualActive";
    FraktBondState["PerpetualRepaid"] = "perpetualRepaid";
    FraktBondState["PerpetualLiquidatedByAuction"] = "perpetualLiquidatedByAuction";
    FraktBondState["PerpetualLiquidatedByClaim"] = "perpetualLiquidatedByClaim";
})(FraktBondState || (exports.FraktBondState = FraktBondState = {}));
var BondTradeTransactionV2State;
(function (BondTradeTransactionV2State) {
    BondTradeTransactionV2State["NotActive"] = "notActive";
    BondTradeTransactionV2State["Active"] = "active";
    BondTradeTransactionV2State["PerpetualActive"] = "perpetualActive";
    BondTradeTransactionV2State["PerpetualRepaid"] = "perpetualRepaid";
    BondTradeTransactionV2State["PerpetualLiquidatedByAuction"] = "perpetualLiquidatedByAuction";
    BondTradeTransactionV2State["PerpetualLiquidatedByClaim"] = "perpetualLiquidatedByClaim";
    BondTradeTransactionV2State["PerpetualManualTerminating"] = "perpetualManualTerminating";
    BondTradeTransactionV2State["PerpetualPartialRepaid"] = "perpetualPartialRepaid";
    BondTradeTransactionV2State["PerpetualRefinanceRepaid"] = "perpetualRefinanceRepaid";
    BondTradeTransactionV2State["PerpetualRefinancedActive"] = "perpetualRefinancedActive";
    BondTradeTransactionV2State["Migrated"] = "migrated";
    BondTradeTransactionV2State["PerpetualBorrowerListing"] = "perpetualBorrowerListing";
    BondTradeTransactionV2State["PerpetualLenderListing"] = "perpetualLenderListing";
    BondTradeTransactionV2State["PerpetualSellingLoan"] = "perpetualSellingLoan";
    BondTradeTransactionV2State["PerpetualSellingListing"] = "perpetualSellingListing";
    BondTradeTransactionV2State["PerpetualSellingListingClosed"] = "perpetualSellingListingClosed";
    BondTradeTransactionV2State["PerpetualAddCollateralClosed"] = "perpetualAddCollateralClosed";
    BondTradeTransactionV2State["PerpetualAutoTerminating"] = "perpetualAutoTerminating";
})(BondTradeTransactionV2State || (exports.BondTradeTransactionV2State = BondTradeTransactionV2State = {}));
var CollateralBoxType;
(function (CollateralBoxType) {
    CollateralBoxType["Escrow"] = "escrow";
    CollateralBoxType["Escrowless"] = "escrowless";
})(CollateralBoxType || (exports.CollateralBoxType = CollateralBoxType = {}));
var BondFeatures;
(function (BondFeatures) {
    BondFeatures["None"] = "none";
    BondFeatures["Autocompound"] = "autocompound";
    BondFeatures["ReceiveNftOnLiquidation"] = "receiveNftOnLiquidation";
    BondFeatures["AutoreceiveSol"] = "autoreceiveSol";
    BondFeatures["AutoCompoundAndReceiveNft"] = "autoCompoundAndReceiveNft";
    BondFeatures["AutoReceiveAndReceiveNft"] = "autoReceiveAndReceiveNft";
    BondFeatures["AutoReceiveAndReceiveSpl"] = "autoReceiveAndReceiveSpl";
})(BondFeatures || (exports.BondFeatures = BondFeatures = {}));
var BondingCurveType;
(function (BondingCurveType) {
    BondingCurveType["Linear"] = "linear";
    BondingCurveType["Exponential"] = "exponential";
    BondingCurveType["LinearUsdc"] = "linearUsdc";
    BondingCurveType["ExponentialUsdc"] = "exponentialUsdc";
    BondingCurveType["LinearBanxSol"] = "linearBanxSol";
    BondingCurveType["ExponentialBanxSol"] = "exponentialBanxSol";
})(BondingCurveType || (exports.BondingCurveType = BondingCurveType = {}));
var PairType;
(function (PairType) {
    PairType["TokenForNFT"] = "tokenForNft";
    PairType["NftForToken"] = "nftForToken";
    PairType["LiquidityProvision"] = "liquidityProvision";
})(PairType || (exports.PairType = PairType = {}));
var NftValidationWhitelistType;
(function (NftValidationWhitelistType) {
    NftValidationWhitelistType["Creator"] = "creator";
    NftValidationWhitelistType["Nft"] = "nft";
    NftValidationWhitelistType["MerkleTree"] = "merkleTree";
    NftValidationWhitelistType["CollectionId"] = "collectionId";
    NftValidationWhitelistType["SplMint"] = "splMint";
    NftValidationWhitelistType["CoreCollection"] = "coreCollection";
})(NftValidationWhitelistType || (exports.NftValidationWhitelistType = NftValidationWhitelistType = {}));
var OrderType;
(function (OrderType) {
    OrderType["Buy"] = "buy";
    OrderType["Sell"] = "sell";
})(OrderType || (exports.OrderType = OrderType = {}));
var OraclePriceFeedType;
(function (OraclePriceFeedType) {
    OraclePriceFeedType["None"] = "none";
    OraclePriceFeedType["Pyth"] = "pyth";
    OraclePriceFeedType["Switchboard"] = "switchboard";
})(OraclePriceFeedType || (exports.OraclePriceFeedType = OraclePriceFeedType = {}));
var MarketState;
(function (MarketState) {
    MarketState["Initializing"] = "initializing";
    MarketState["Available"] = "available";
    MarketState["InitializingPerpetual"] = "initializingPerpetual";
    MarketState["AvailablePerpetual"] = "availablePerpetual";
    MarketState["PrivateAvailablePerpetual"] = "privateAvailablePerpetual";
})(MarketState || (exports.MarketState = MarketState = {}));
var MarketTrustType;
(function (MarketTrustType) {
    MarketTrustType["Unverified"] = "unverified";
    MarketTrustType["Verified"] = "verified";
})(MarketTrustType || (exports.MarketTrustType = MarketTrustType = {}));
var PairValidationType;
(function (PairValidationType) {
    PairValidationType["ClassicValidation"] = "classicValidation";
    PairValidationType["CustomValidation"] = "customValidation";
})(PairValidationType || (exports.PairValidationType = PairValidationType = {}));
var PairTokenType;
(function (PairTokenType) {
    PairTokenType["NativeSol"] = "nativeSol";
    PairTokenType["Spl"] = "spl";
})(PairTokenType || (exports.PairTokenType = PairTokenType = {}));
var WhitelistType;
(function (WhitelistType) {
    WhitelistType["Nft"] = "nft";
    WhitelistType["Creator"] = "creator";
})(WhitelistType || (exports.WhitelistType = WhitelistType = {}));
var RepayDestination;
(function (RepayDestination) {
    RepayDestination["None"] = "none";
    RepayDestination["Offer"] = "offer";
    RepayDestination["Wallet"] = "wallet";
    RepayDestination["Vault"] = "vault";
})(RepayDestination || (exports.RepayDestination = RepayDestination = {}));
var LendingTokenType;
(function (LendingTokenType) {
    LendingTokenType["NativeSol"] = "nativeSol";
    LendingTokenType["Usdc"] = "usdc";
    LendingTokenType["BanxSol"] = "banxSol";
})(LendingTokenType || (exports.LendingTokenType = LendingTokenType = {}));
var RedeemResult;
(function (RedeemResult) {
    RedeemResult["None"] = "none";
    RedeemResult["DirectBorrow"] = "directBorrow";
    RedeemResult["Reborrow"] = "reborrow";
    RedeemResult["InstantRefinanced"] = "instantRefinanced";
    RedeemResult["RefinancedByAuction"] = "refinancedByAuction";
    RedeemResult["PartialRepay"] = "partialRepay";
    RedeemResult["DirectRepaid"] = "directRepaid";
    RedeemResult["Claimed"] = "claimed";
    RedeemResult["AddCollateral"] = "addCollateral";
})(RedeemResult || (exports.RedeemResult = RedeemResult = {}));
var PairState;
(function (PairState) {
    PairState["Initializing"] = "initializing";
    PairState["OnMarketVirtual"] = "onMarketVirtual";
    PairState["OnMarketTokenized"] = "onMarketTokenized";
    PairState["Frozen"] = "frozen";
    PairState["Closed"] = "closed";
    PairState["PerpetualOnMarket"] = "perpetualOnMarket";
    PairState["PerpetualClosed"] = "perpetualClosed";
    PairState["PerpetualBondingCurveOnMarket"] = "perpetualBondingCurveOnMarket";
    PairState["PerpetualMigrated"] = "perpetualMigrated";
    PairState["PerpetualBondingCurveClosed"] = "perpetualBondingCurveClosed";
    PairState["PerpetualListing"] = "perpetualListing";
})(PairState || (exports.PairState = PairState = {}));
var PairAuthorityType;
(function (PairAuthorityType) {
    PairAuthorityType["ClassicAuthority"] = "classicAuthority";
    PairAuthorityType["CustomAuthority"] = "customAuthority";
})(PairAuthorityType || (exports.PairAuthorityType = PairAuthorityType = {}));
var AuthorityType;
(function (AuthorityType) {
    AuthorityType["Persistent"] = "persistent";
    AuthorityType["OneTime"] = "oneTime";
})(AuthorityType || (exports.AuthorityType = AuthorityType = {}));
var AuthorityState;
(function (AuthorityState) {
    AuthorityState["Active"] = "active";
    AuthorityState["Used"] = "used";
    AuthorityState["Expired"] = "expired";
    AuthorityState["Revoked"] = "revoked";
})(AuthorityState || (exports.AuthorityState = AuthorityState = {}));
var ScopeType;
(function (ScopeType) {
    ScopeType["Market"] = "market";
    ScopeType["Pair"] = "pair";
})(ScopeType || (exports.ScopeType = ScopeType = {}));
var NftValidationDurationType;
(function (NftValidationDurationType) {
    NftValidationDurationType["Finite"] = "finite";
    NftValidationDurationType["Infinite"] = "infinite";
})(NftValidationDurationType || (exports.NftValidationDurationType = NftValidationDurationType = {}));
var NftBoxType;
(function (NftBoxType) {
    NftBoxType["Escrow"] = "escrow";
    NftBoxType["Escrowless"] = "escrowless";
})(NftBoxType || (exports.NftBoxType = NftBoxType = {}));
var NftBoxState;
(function (NftBoxState) {
    NftBoxState["NotActive"] = "notActive";
    NftBoxState["Active"] = "active";
})(NftBoxState || (exports.NftBoxState = NftBoxState = {}));
var AutocompoundDepositState;
(function (AutocompoundDepositState) {
    AutocompoundDepositState["NotActive"] = "notActive";
    AutocompoundDepositState["Active"] = "active";
    AutocompoundDepositState["Removed"] = "removed";
})(AutocompoundDepositState || (exports.AutocompoundDepositState = AutocompoundDepositState = {}));
var BondTradeTransactionV2Type;
(function (BondTradeTransactionV2Type) {
    BondTradeTransactionV2Type["None"] = "none";
    BondTradeTransactionV2Type["Autocompound"] = "autocompound";
    BondTradeTransactionV2Type["ReceiveNftOnLiquidation"] = "receiveNftOnLiquidation";
    BondTradeTransactionV2Type["AutoreceiveSol"] = "autoreceiveSol";
    BondTradeTransactionV2Type["AutoCompoundAndReceiveNft"] = "autoCompoundAndReceiveNft";
    BondTradeTransactionV2Type["AutoReceiveAndReceiveNft"] = "autoReceiveAndReceiveNft";
    BondTradeTransactionV2Type["AutoReceiveAndReceiveSpl"] = "autoReceiveAndReceiveSpl";
})(BondTradeTransactionV2Type || (exports.BondTradeTransactionV2Type = BondTradeTransactionV2Type = {}));
var AutocompoundType;
(function (AutocompoundType) {
    AutocompoundType["Autocompound"] = "autocompound";
    AutocompoundType["AutoreceiveSol"] = "autoreceiveSol";
    AutocompoundType["AutocompoundAndReceiveNft"] = "autocompoundAndReceiveNft";
})(AutocompoundType || (exports.AutocompoundType = AutocompoundType = {}));
var BondEventType;
(function (BondEventType) {
    BondEventType["Creation"] = "creation";
    BondEventType["Repay"] = "repay";
    BondEventType["Liquidating"] = "liquidating";
    BondEventType["Liquidated"] = "liquidated";
    BondEventType["Redeem"] = "redeem";
    BondEventType["Refinance"] = "refinance";
})(BondEventType || (exports.BondEventType = BondEventType = {}));
var BanxStakeState;
(function (BanxStakeState) {
    BanxStakeState["Staked"] = "staked";
    BanxStakeState["Unstaked"] = "unstaked";
    BanxStakeState["Liquidated"] = "liquidated";
})(BanxStakeState || (exports.BanxStakeState = BanxStakeState = {}));
var AdventureState;
(function (AdventureState) {
    AdventureState["Uninitialized"] = "uninitialized";
    AdventureState["Initialized"] = "initialized";
    AdventureState["DistributingInitialized"] = "distributingInitialized";
})(AdventureState || (exports.AdventureState = AdventureState = {}));
var BanxAdventureSubscriptionState;
(function (BanxAdventureSubscriptionState) {
    BanxAdventureSubscriptionState["None"] = "none";
    BanxAdventureSubscriptionState["Active"] = "active";
    BanxAdventureSubscriptionState["Claimed"] = "claimed";
})(BanxAdventureSubscriptionState || (exports.BanxAdventureSubscriptionState = BanxAdventureSubscriptionState = {}));
var BanxAdventureState;
(function (BanxAdventureState) {
    BanxAdventureState["None"] = "none";
    BanxAdventureState["Active"] = "active";
})(BanxAdventureState || (exports.BanxAdventureState = BanxAdventureState = {}));
var BanxStakingSettingsState;
(function (BanxStakingSettingsState) {
    BanxStakingSettingsState["None"] = "none";
    BanxStakingSettingsState["Active"] = "active";
})(BanxStakingSettingsState || (exports.BanxStakingSettingsState = BanxStakingSettingsState = {}));
var BanxTokenStakeState;
(function (BanxTokenStakeState) {
    BanxTokenStakeState["None"] = "none";
    BanxTokenStakeState["Staked"] = "staked";
    BanxTokenStakeState["Unstaked"] = "unstaked";
})(BanxTokenStakeState || (exports.BanxTokenStakeState = BanxTokenStakeState = {}));
var ProposalState;
(function (ProposalState) {
    ProposalState["None"] = "none";
    ProposalState["Initialized"] = "initialized";
})(ProposalState || (exports.ProposalState = ProposalState = {}));
var UserVaultState;
(function (UserVaultState) {
    UserVaultState["None"] = "none";
    UserVaultState["Active"] = "active";
})(UserVaultState || (exports.UserVaultState = UserVaultState = {}));
